module.exports = __webpack_public_path__ + "static/media/sort_black_rich.09e1e734.svg";


//////////////////
// WEBPACK FOOTER
// ./src/res/img/sort_black_rich.svg
// module id = 348
// module chunks = 0